import gql from 'graphql-tag'
import { graphql, ChildDataProps } from 'react-apollo'

export type InputProps = {
  projectNumber: string
  projectName: string
  company?: string
  hourlyRate?: number
  tax: number
  date?: Date
  contact: string
  street?: string
  zipCode?: string
  city?: string
  country?: string
  description?: string
  currentProjectNumber: string
}

export type Variables = {
  projectNumber: string
  projectName: string
  company?: string
  hourlyRate?: number
  tax: number
  date?: Date
  contact: string
  street?: string
  zipCode?: string
  city?: string
  country?: string
  description?: string
  currentProjectNumber: string
}

export type Response = {}

type ChildProps = ChildDataProps<InputProps, Response, Variables>

const PROJECT_DATA_MUTATION = gql`
  mutation updateProject(
    $projectNumber: String!
    $projectName: String!
    $company: String
    $hourlyRate: Float
    $tax: Float!
    $date: DateTime
    $contact: String!
    $street: String!
    $zipCode: String!
    $city: String!
    $country: String!
    $description: String
    $currentProjectNumber: String!
  ) {
    updateProject(
      projectNumber: $projectNumber
      projectName: $projectName
      company: $company
      hourlyRate: $hourlyRate
      tax: $tax
      date: $date
      contact: $contact
      street: $street
      zipCode: $zipCode
      city: $city
      country: $country
      description: $description
      currentProjectNumber: $currentProjectNumber
    )
  }
`

const withProjectDataMutation = graphql<InputProps, Response, Variables, ChildProps>(
  PROJECT_DATA_MUTATION,
)

export default withProjectDataMutation
